"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
exports.useToggle = (initialState = false) => {
    const [isOpen, setIsOpen] = react_1.useState(initialState);
    const toggle = react_1.useCallback((newState) => {
        if (typeof newState === "boolean") {
            return setIsOpen(newState);
        }
        setIsOpen((state) => !state);
    }, []);
    return react_1.useMemo(() => [isOpen, toggle], [isOpen, toggle]);
};
//# sourceMappingURL=use-toggle.js.map